import { useCallback, useEffect, useState } from 'react';
import { callAgoGetWithRetry } from '../auth/portalSession';

export async function fetchPersonalInsurancePendingSummary(fleetCode) {
  if (!fleetCode) {
    throw new Error('fleet_code is required');
  }
  return callAgoGetWithRetry({
    api_endpoint: 'api3:staff:personal_insurance_reviews',
    request_type: 'GET',
    mode: 'summary',
    fleet_code: fleetCode,
  });
}

export function usePersonalInsurancePendingSummary({ enabled = true, fleetCode, refreshKey = 0 } = {}) {
  const [totalPending, setTotalPending] = useState(0);
  const [byFleet, setByFleet] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || !fleetCode) {
      setTotalPending(0);
      setByFleet([]);
      return;
    }
    setLoading(true);
    try {
      const res = await fetchPersonalInsurancePendingSummary(fleetCode);
      setTotalPending(Number(res?.total_pending) || 0);
      setByFleet(Array.isArray(res?.by_fleet) ? res.by_fleet : []);
    } catch (e) {
      setTotalPending(0);
      setByFleet([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, fleetCode]);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  return { totalPending, byFleet, loading, refresh };
}

export function portalRoleShowsPersonalInsuranceReview(role) {
  return role === 'admin' || role === 'fleet' || role === 'support';
}
